export const defaultState = {}

export const recruiterTypes = {
  corporate: "corporate",
  headhunter: "headhunter",
}

export const defaultIndustry = {
  id: "all",
  translationKey: "360_RECRUITER_INSIGHTS_BENCHMARKS_PICKER_ALL_INDUSTRIES",
}

export const defaultCompanySize = {
  id: "all",
  translationKey: "360_RECRUITER_INSIGHTS_BENCHMARKS_PICKER_ALL_SIZES",
}

export const defaultRecruiterType = recruiterTypes.corporate
